import SimpleTabListExample from "./examples/TabList.Simple.Example";
import SimpleTabBarExample from "./examples/TabBar.Simple.Example";
import SimpleTabBarWithIconsExample from "./examples/TabBarWithIcons.Simple.Example";

export default [
    {
        title: "Basic tab bar",
        component: SimpleTabBarExample,
        code: require("!raw-loader!./examples/TabBar.Simple.Example.tsx"),
        stretchContainer: true
    },
    {
        title: "Basic tab bar with icons",
        component: SimpleTabBarWithIconsExample,
        code: require("!raw-loader!./examples/TabBarWithIcons.Simple.Example.tsx"),
        stretchContainer: true
    },
    {
        title: "Basic tab list",
        component: SimpleTabListExample,
        code: require("!raw-loader!./examples/TabList.Simple.Example")
    }
];
